import _ from "lodash";
import { login, identityLogin } from "@/api/login";
import router from "@/router";
import store from "@/store";
import config from "@/config";

export const TOKEN_KEY = "jwt-token";
export const IS_IDENTITY_LOGIN_KEY = "is-identity-login";
const token = localStorage.getItem(TOKEN_KEY) || null;

const state = () => ({
    token: token
});

const getters = {
    loggedIn: (state, getters, rootState) => {
        return !_.isEmpty(state.token);
    }
};

function goBack(): void {
    const previewUrl = store.getters["base/previewUrl"];
    if (!_.isEmpty(previewUrl)) {
        router.replace(previewUrl).catch();
        return;
    }
    router.replace({ name: "Home" }).catch();
}

function redirectIdentityLogout(err): void {
    let redirectUrl = config.INTERNAL_IDENTITY_URL + "/logout?service=" + encodeURI(window.location.origin) + "/my";
    if (err) {
        redirectUrl += "?err=" + err;
    }
    window.location.href = redirectUrl;
}

const actions = {
    login: ({ commit }, { username, password }) => {
        login(username, password)
            .then(resp => {
                commit("loginSuccess", resp.data.data.token);
                goBack();
            })
            .catch(ignore => {
                commit("logout");
            });
    },
    identityLogin: ({ commit }, { ticket, service }) => {
        identityLogin(ticket, service)
            .then(resp => {
                localStorage.setItem(IS_IDENTITY_LOGIN_KEY, "true");
                commit("loginSuccess", resp.data.data.token);
                goBack();
            })
            .catch(ignore => {
                commit("logout");
                redirectIdentityLogout(ignore.response.data.message);
            });
    },
    logout: ({ commit }) => {
        commit("logout");
        if (localStorage.getItem(IS_IDENTITY_LOGIN_KEY)) {
            localStorage.removeItem(IS_IDENTITY_LOGIN_KEY);
            redirectIdentityLogout(null);
            return;
        }
        if (router.currentRoute.name == "My") {
            router.replace("/").catch();
        }
    }
};

const mutations = {
    loginSuccess: (state, token) => {
        localStorage.setItem(TOKEN_KEY, token);
        state.token = token;
    },
    logout: state => {
        localStorage.removeItem(TOKEN_KEY);
        state.token = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
